import { Pipe, PipeTransform } from '@angular/core';
import { SummaryCompletedWorkModel } from '../symbols';


@Pipe({
  name: 'totalSalary',
  standalone: true
})
export class TotalSalaryPipe implements PipeTransform {
  transform(value: SummaryCompletedWorkModel[]): number {
    return value.reduce((a, b) => {
      if (b.totalSum > 0) {
        return a + b.totalSum;
      }
      return a;
    }, 0);
  }
}
